<template>
    <div>
        <!--        <nav class="navbar navbar-expand-lg navbar-light">-->
        <div class="ml-auto mb-2">
            <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchImportProduct">
                <!--                    <input-->
                <!--                        class="form-control mr-sm-2"-->
                <!--                        type="search"-->
                <!--                        placeholder="รหัสสินค้า"-->
                <!--                        aria-label="Search"-->
                <!--                        v-model="form.code"/>-->
                <multiselect
                    style="height: 100%"
                    v-model="form.code"
                    class="form-control border-0"
                    :options="optionProducts"
                    :customLabel="LabelSkuWithName"
                    placeholder="ค้นหาสินค้า"
                    :show-labels="false"
                    :close-on-select="false"
                    multiple
                    :searchable="true"
                    track-by="id">
                </multiselect>
                &nbsp
                <date-picker
                    v-model="form.date"
                    type="datetime"
                    :format="changeFormat"
                    :range="true"
                    :lang="lang"
                    confirm
                    placeholder="วันที่อัพเดต">
                </date-picker>
                &nbsp
                <multiselect class="w-25" multiple placeholder="เลือกประเภทสินค้า" :customLabel="customLabelType"
                             track-by="value" :options="optionProductType" v-model="form.product_type"></multiselect>&nbsp;
                &nbsp
                <button
                    class="btn btn-success my-2 my-sm-0"
                    type="button"
                    @click="searchImportProduct">
                    <icon name="search"></icon>
                    ค้นหา
                </button>
                &nbsp
                <button type="button" class="btn btn-primary my-2 my-sm-0"
                        @click="printReportExcel">
                    <icon name="file-download"></icon>
                    พิมพ์ Excel
                </button>
                &nbsp
                <button type="button" class="btn btn-primary my-2 my-sm-0"
                        @click="printReportPDF">
                    <icon name="file-download"></icon>
                    พิมพ์ PDF
                </button>
            </form>
        </div>
        <!--        </nav>-->
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">เครื่อง</th>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนสินค้านำเข้า</th>
                    <th scope="col">ผู้นำเข้า</th>
                    <th scope="col">วัน/เวลา ที่นำเข้า</th>
                    <th scope="col" v-if="canViewSuperAdmin">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in importProducts">
                    <td>
                        <template v-if="data.machine">
                            {{ data.machine.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.product">
                            {{ data.product.sku }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.product">
                            {{ data.product.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.quantity | amount }}</td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , HH:mm:ss") }}</td>
                    <td v-if="canViewSuperAdmin">
                        <a @click="showImportProduct(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="importProducts.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getProductsImportPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- Modal Delete -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteImportProduct">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal Report Print -->
        <b-modal hide-header hide-footer ref="report_print">
            <div style="text-align: center;">
                <h4>พิมพ์ข้อมูลนำเข้าสินค้า</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-sm-4">
                        <label>วันที่นำเข้าสินค้า</label>
                    </div>
                    <div class="col-sm-6">
                        <date-picker
                            v-model="date_print"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="วันที่นำเข้าสินค้า">
                        </date-picker>
                    </div>
                </div>
                <button @click="printReportImportProduct"
                        type="button"
                        class="btn btn-primary">
                    <icon name="print"></icon>
                    พิมพ์
                </button>
                &nbsp&nbsp
                <button @click="hidePrintReportModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal edit Data -->
        <b-modal
            hide-footer
            ref="edit_data"
            id="import"
            title="นำเข้าวัตถุดิบ">
            <div v-if="edit_product.product">
                <b-row sm="10" v-if="edit_product.product">
                    <b-col sm="4" class="col text-right">
                        <label>รหัสสินค้า</label>
                    </b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="text"
                        v-model="edit_product.product.sku" disabled/></b-col>
                </b-row>
                <br/>
                <b-row sm="10" v-if="edit_product.product">
                    <b-col sm="4" class="col text-right">
                        <label>ชื่อสินค้า</label></b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="text"
                            v-model="edit_product.product.name" disabled/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right">
                        <label>จำนวนสินค้านำเข้า</label>
                    </b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="text"
                        v-model="edit_product.quantity"/></b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right">
                        <label>เครื่อง</label>
                    </b-col>
                    <b-col sm="6">
                        <multiselect
                            v-model="edit_product.machine"
                            :options="machine"
                            label="name"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <div class="col text-center">
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="saveImportProduct">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp&nbsp
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            @click="hideEditModal">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
            <!--<pre class="alert alert-primary">{{ edit_product }}</pre>-->
        </b-modal>
        <!--<pre class="alert alert-primary">{{ importProducts }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import Modal from "bootstrap-vue/es/components/modal/modal";
import VuePagination from "../../Pagination";
import {domain} from "../../../util/Constants";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {canViewSuperAdmin} from "../../../util/Permissions";

export default {
    components: {
        VuePagination,
        Modal,
        Multiselect,
        DatePicker
    },
    name: "import-products",
    data() {
        return {
            id: "",
            dateFormat: 'D/MM/YYYY',
            date_print: "",
            form: {
                code: "",
                date: "",
                shift: "",
                machine: "",
                product_type: "",
                event_submit: false
            },
            importProducts: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        this.$store.dispatch("ImportProduct/get").then(res => {
            this.importProducts = res.data;
            this.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        });
        this.$store.dispatch("Machine/get");
        this.domain = domain;
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            edit_product: state => {
                return state.ImportProduct.replace_data;
            },
            machine: state => {
                return state.Machine.data;
            },
            optionProductType: state => {
                return [
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            optionProducts: state => {
                return state.ProductType.product;
            },
        })
    },
    methods: {
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.name}`
            }
        },
        customLabelType(option) {
            return `${option.text}`
        },
        clearDate() {
            this.form.date = "";
        },
        LabelName(option) {
            return `${option.id}`;
        },
        //Modal
        showDeleteModal(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },

        showEditModal(id) {
            this.id = id;
            this.$refs.edit_data.show();
        },
        hideEditModal() {
            this.$refs.edit_data.hide();
        },

        showPrintReportModal() {
            this.$refs.report_print.show();
        },
        hidePrintReportModal() {
            this.$refs.report_print.hide();
        },

        //API
        showImportProduct(id) {
            this.$store.dispatch("ImportProduct/show", id).then(() => {
                this.machine.forEach(machine => {
                    if (machine.machine_id === this.edit_product.machine) {
                        this.form.machine = machine;
                    }
                })
            });
            this.showEditModal(id);
        },
        deleteImportProduct() {
            this.$store.dispatch("ImportProduct/delete", this.id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch("ImportProduct/get");
                this.$store.dispatch("Products/setProducts");
            });
        },
        saveImportProduct() {
            if (this.edit_product.quantity < 1) {
                alert("กรุณาใส่จำนวนให้ถูกต้อง");
            } else {
                let data = {
                    product_id: this.edit_product.product_id,
                    quantity: this.edit_product.quantity,
                    machine_id: "", //send machine_id
                    user_id: this.user.id
                };
                if (this.edit_product.machine) {
                    data.machine_id = this.edit_product.machine.id
                }
                this.$store
                    .dispatch("ImportProduct/update", {
                        id: this.id,
                        data: data
                    })
                    .then(() => {
                        this.hideEditModal();
                        this.$store.dispatch("ImportProduct/get");
                        this.$store.dispatch("Products/setProducts");
                    });
            }
        },
        searchImportProduct() {
            let date_start = '';
            let date_end = '';
            if (this.form.date) {
                date_start = moment(this.form.date[0]).format("YYYY-MM-DD HH:mm:ss");
                date_end = moment(this.form.date[1]).format("YYYY-MM-DD HH:mm:ss");
            }
            let type_id = '';
            if (this.form.product_type) {
                this.form.product_type.forEach((x, i) => {
                    if (i > 0) type_id += ',' + x.value
                    else type_id += x.value
                })
            }
            let product_id = '';
            if (this.form.code.length > 0) {
                this.form.code.forEach((v, i) => {
                    i > 0 ? product_id += ',' + v.id : product_id += v.id;
                })
            }
            this.event_submit = true;
            this.$store.dispatch("ImportProduct/search", {
                code: product_id,
                date_start: date_start,
                date_end: date_end,
                type_id: type_id
            }).then(res => {
                this.importProducts = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.form,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            });
        },
        getProductsImportPage() {
            const page = this.dataPaginate.current_page;
            // paginate search
            if (this.form.date) {
                this.form.date = moment(this.form.date).format("YYYY-MM-DD");
            } else {
                this.form.date = ""
            }
            if (this.event_submit) {
                this.$store.dispatch('ImportProduct/search', {
                    page: page,
                    code: this.form.code,
                    date: this.form.date
                });
            } else {
                //paginate get data
                this.$store.dispatch('ImportProduct/get', page)
            }
        },
        printReportImportProduct() {
            if (!this.form.date) {
                alert("กรุณาเลือกวันที่นำเข้า ที่ต้องการพิมพ์")
            } else {
                let date_start = moment(this.form.date[0]).format("YYYY-MM-DD");
                let date_end = moment(this.form.date[1]).format("YYYY-MM-DD");
                let code = this.form.code;
                window.open(this.domain + '/product-import-pdf' + "?date_start=" + date_start + "&date_end=" + date_end + "&code=" + code);
            }
        },
        printReportExcel() {
            if (!this.form.date) {
                alert("กรุณาเลือกวันที่นำเข้า ที่ต้องการพิมพ์")
            } else {
                let date_start = moment(this.form.date[0]).format("YYYY-MM-DD HH:mm:ss");
                let date_end = moment(this.form.date[1]).format("YYYY-MM-DD HH:mm:ss");
                // let code = this.form.code;
                let product_id = '';
                if (this.form.code.length > 0) {
                    this.form.code.forEach((v, i) => {
                        i > 0 ? product_id += ',' + v.id : product_id += v.id;
                    })
                }
                let type_id = '';
                if (this.form.product_type) {
                    this.form.product_type.forEach((x, i) => {
                        if (i > 0) type_id += ',' + x.value
                        else type_id += x.value
                    })
                }
                window.open(this.domain + '/print-import-product' + "?date_start=" + date_start + "&date_end=" + date_end + "&code=" + product_id + "&type_id=" + type_id + "&file=excel");
            }
        },
        printReportPDF() {
            if (!this.form.date) {
                alert("กรุณาเลือกวันที่นำเข้า ที่ต้องการพิมพ์")
            } else {
                let date_start = moment(this.form.date[0]).format("YYYY-MM-DD HH:mm:ss");
                let date_end = moment(this.form.date[1]).format("YYYY-MM-DD HH:mm:ss");
                // let code = this.form.code;
                let product_id = '';
                if (this.form.code.length > 0) {
                    this.form.code.forEach((v, i) => {
                        i > 0 ? product_id += ',' + v.id : product_id += v.id;
                    })
                }
                let type_id = '';
                if (this.form.product_type) {
                    this.form.product_type.forEach((x, i) => {
                        if (i > 0) type_id += ',' + x.value
                        else type_id += x.value
                    })
                }
                window.open(this.domain + '/print-import-product' + "?date_start=" + date_start + "&date_end=" + date_end + "&code=" + product_id + "&type_id=" + type_id + "&file=pdf");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.picker {
    border: 0;
}
</style>
